import React, { useState } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import Sidebar from "../Common/Sidebar";
import { Box, Drawer } from "@mui/material";
import { styled } from "@mui/material/styles";
import CreateTenantModal from "../Dashboard/CreateTenantModal";
import Header from "../Common/Header";
import { createTenant } from "../../features/createTenant/createTenantAction";
import { getTenantDetail } from "../../features/tenantDetail/tenantDetailAction";
import { useDispatch } from "react-redux";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  IconAdjustmentsStar,
  IconChecklist,
  IconDashboard,
  IconPrompt,
  IconUsersGroup,
} from "@tabler/icons-react";

const drawerWidth = 240;

const MiniDrawer = styled((props) => <Drawer {...props} />)(
  ({ theme, open }) => ({
    width: open ? drawerWidth : 72,
    flexShrink: 0,
    whiteSpace: "nowrap",
    overflowX: "hidden",
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
    "& .MuiDrawer-paper": {
      width: open ? drawerWidth : 72,
      gap: open ? 0 : 8,
      backgroundColor: "#1976d2",
      transition: theme.transitions.create("width", {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen,
      }),
    },
  })
);

const AppLayout = () => {
  const [openDrawer, setOpenDrawer] = useState(true);
  const [openModal, setOpenModal] = useState(false);
  const [tenantName, setTenantName] = useState("");
  const [domainName, setDomainName] = useState("");
  const [tenantStatus, setTenantStatus] = useState("Active");
  const [primaryStatus, setPrimaryStatus] = useState(false);
  const [expirationDate, setExpirationDate] = useState("");
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const navigationItems = [
    {
      text: "Tenants",
      icon: <IconUsersGroup stroke={2} color="#ffffff" />,
      onClick: () => navigate("/dashboard"),
    },
    {
      text: "Features",
      icon: <IconDashboard stroke={2} color="#ffffff" />,
      onClick: () => navigate("/features"),
    },
    {
      text: "Prompt",
      icon: <IconPrompt stroke={2} color="#ffffff" />,
      onClick: () => navigate("/prompt"),
    },
    {
      text: "System Prompt",
      icon: <IconAdjustmentsStar stroke={2} color="#ffffff" />,
      onClick: () => navigate("/system-prompt"),
    },
    {
      text: "Global Checkpoints",
      icon: <IconChecklist stroke={2} color="#ffffff" />,
      onClick: () => navigate("/global-checkpoints"),
    },
  ];

  const toggleDrawer = () => {
    setOpenDrawer(!openDrawer);
  };

  const handleLogout = () => {
    localStorage.clear();
    dispatch({ type: "RESET_STATE" });
    navigate("/login", { replace: true });
  };

  const handleCreateTenant = () => {
    setOpenModal(true);
  };

  const handleCloseModal = () => {
    setOpenModal(false);
  };

  const handleAddTenant = () => {
    if (tenantName.trim() && expirationDate.trim()) {
      const newTenant = {
        tenant: tenantName,
        status: tenantStatus,
        expiry: expirationDate,
        domain: domainName,
        tenantStatus: tenantStatus,
        isPrimary: primaryStatus,
      };      
      dispatch(createTenant(newTenant))
        .then((res) => {
          if (res.payload && res.payload.data) {
            dispatch(getTenantDetail());
            toast.success(
              res.payload.message || "Tenant created successfully!"
            );
          } else if (res.error) {
            toast.error(res.error.message || "Tenant creation failed!");
          }
        })
        .catch((err) => {
          toast.error(err.message || "An unexpected error occurred!");
        });
      setOpenModal(false);
      setTenantName("");
      setDomainName("");
      setTenantStatus("Active");
      setExpirationDate("");
      setPrimaryStatus(false);
    }
  };

  return (
    <Box>
      <Box>
        <Sidebar
          navigationItems={navigationItems}
          MiniDrawer={MiniDrawer}
          toggleDrawer={toggleDrawer}
          openDrawer={openDrawer}
          handleLogout={handleLogout}
          handleCreateTenant={handleCreateTenant}
        />
        <Header
          openDrawer={openDrawer}
          handleCreateTenant={handleCreateTenant}
          handleLogout={handleLogout}
        />
        <CreateTenantModal
          tenantStatus={tenantStatus}
          setTenantStatus={setTenantStatus}
          setExpirationDate={setExpirationDate}
          setPrimaryStatus={setPrimaryStatus}
          primaryStatus={primaryStatus}
          openModal={openModal}
          handleCloseModal={handleCloseModal}
          handleAddTenant={handleAddTenant}
          tenantName={tenantName}
          setTenantName={setTenantName}
          domainName={domainName}
          setDomainName={setDomainName}
          expirationDate={expirationDate}
        />
        <Box
          sx={{
            transition: "all 225ms cubic-bezier(0.4, 0, 0.6, 1) 0ms",
            width: openDrawer ? "calc(100% - 240px)" : "calc(100% - 72px)",
            marginLeft: openDrawer ? "240px" : "72px",
          }}
        >
          <Outlet />
        </Box>
      </Box>
      <ToastContainer />
    </Box>
  );
};

export default AppLayout;
